/**
 * Should be used in components firstUpdate and let's you execute
 * a function that you will need to do after the DomContentLoaded is completed
 *
 * @param fn - component's function
 *
 * Usage Example:
 * domLoaded(this.myfunction);
 */
import { addListener } from '@elab/core/utils/webComponent';
import { documentEvents } from '@elab/core/utils/eventConstants';

export const domLoaded = fn => {
    const unsubscribe1 = addListener(document, 'turbolinks:load', fn);
    const unsubscribe2 = addListener(document, documentEvents.NOT_COMMON_COMPONENTS_READY, fn);
    return [unsubscribe1, unsubscribe2];
};
